import { Box } from "@material-ui/core";
import React from "react";
import { Tag } from "./orderDetailsStatus.style";

export const OrderDetailsStatus = ({ status, children, showDate, style = {} }) => {

    const getOrderDetailsStatusColor = (status) => {
        if (status === 'Chegou! Bom apetite!') {
            return '#119C4A';
        }

        return '#D8B462';
    }

    const statusColor = getOrderDetailsStatusColor(status.status);

    return (
        <Box display='flex' flexDirection='column' alignItems='center'>
            <Tag color={statusColor} style={style}>
                {children}
            </Tag>
            {
                showDate && (
                    <Box fontSize='11px' marginTop="2px">
                        {status.date}
                    </Box>
                )
            }
        </Box>
    )
}
